import {gtmEcommerceOfferTypeMap, OfferType} from "@pg-rp/common-types";

import {getGTMEcommerceOfferRegion, IGetGTMEcommerceOfferRegion} from "../../offer/tracking/ecommerce_events/common/get_gtm_ecommerce_offer_region";
import {Currency} from "../../types/Currency";
import {getCurrencyISOCode} from "../../utils/get_currency";

export interface IAmplitudeViewItemOffer {
    id: number;
    name: string;
    type: OfferType;
    currency: Currency;
    vendor: {
        name: string;
    };
    region: IGetGTMEcommerceOfferRegion;
}

export interface IAmplitudeViewItemProperty {
    id: number;
    number: string;
    area?: number;
    rooms?: number;
    floor?: number;
    price?: number | null;
}

export interface IGetAmplitudeViewItemEventPropertiesParams {
    offer: IAmplitudeViewItemOffer;
    property?: IAmplitudeViewItemProperty;
    itemListId?: string;
    itemListName?: string;
}

const getAmplitudeViewItemRegionProperties = (region?: IGetGTMEcommerceOfferRegion) => {
    const regionProperties = getGTMEcommerceOfferRegion(region);

    return {
        ...(regionProperties.item_category2 ? {item_category2: regionProperties.item_category2} : {}),
        ...(regionProperties.item_category3 ? {item_category3: regionProperties.item_category3} : {}),
        ...(regionProperties.item_category5
            ? {item_category4: regionProperties.item_category5}
            : regionProperties.item_category4
              ? {item_category4: regionProperties.item_category4}
              : {})
    };
};

export const getAmplitudeViewItemEventProperties = (params: IGetAmplitudeViewItemEventPropertiesParams): Record<string, string | number> => {
    const {offer, property, itemListId, itemListName} = params;

    const eventProperties: Record<string, string | number> = {
        item_id: offer.id,
        item_name: offer.name,
        item_brand: offer.vendor.name,
        item_category: property ? "property" : "investment",
        item_type: gtmEcommerceOfferTypeMap[offer.type],
        currency: getCurrencyISOCode(offer.currency),
        ...getAmplitudeViewItemRegionProperties(offer.region)
    };

    if (itemListId) {
        eventProperties.item_list_id = itemListId;
    }

    if (itemListName) {
        eventProperties.item_list_name = itemListName;
    }

    if (!property) {
        return eventProperties;
    }

    eventProperties.property_id = property.id;
    eventProperties.variant_name = property.number;

    if (property.area != null) {
        eventProperties.variant_area = property.area;
    }

    if (property.rooms != null) {
        eventProperties.variant_rooms = property.rooms;
    }

    if (property.floor != null) {
        eventProperties.variant_floor = property.floor;
    }

    if (property.price != null) {
        eventProperties.price = property.price;
    }

    return eventProperties;
};
import {gtmEcommerceOfferTypeMap, OfferType} from "@pg-rp/common-types";

import {getGTMEcommerceOfferRegion, IGetGTMEcommerceOfferRegion} from "../../offer/tracking/ecommerce_events/common/get_gtm_ecommerce_offer_region";
import {Currency} from "../../types/Currency";
import {getCurrencyISOCode} from "../../utils/get_currency";

export interface IAmplitudeViewItemOffer {
    id: number;
    name: string;
    type: OfferType;
    currency: Currency;
    vendor: {
        name: string;
    };
    region: IGetGTMEcommerceOfferRegion;
}

export interface IAmplitudeViewItemProperty {
    id: number;
    number: string;
    area?: number;
    rooms?: number;
    floor?: number;
    price?: number | null;
}

export interface IGetAmplitudeViewItemEventPropertiesParams {
    offer: IAmplitudeViewItemOffer;
    property?: IAmplitudeViewItemProperty;
    itemListId?: string;
    itemListName?: string;
}

const getAmplitudeViewItemRegionProperties = (region?: IGetGTMEcommerceOfferRegion) => {
    const regionProperties = getGTMEcommerceOfferRegion(region);

    return {
        ...(regionProperties.item_category2 ? {item_category2: regionProperties.item_category2} : {}),
        ...(regionProperties.item_category3 ? {item_category3: regionProperties.item_category3} : {}),
        ...(regionProperties.item_category5
            ? {item_category4: regionProperties.item_category5}
            : regionProperties.item_category4
              ? {item_category4: regionProperties.item_category4}
              : {})
    };
};

export const getAmplitudeViewItemEventProperties = (params: IGetAmplitudeViewItemEventPropertiesParams): Record<string, string | number> => {
    const {offer, property, itemListId, itemListName} = params;

    const eventProperties: Record<string, string | number> = {
        item_id: offer.id,
        item_name: offer.name,
        item_brand: offer.vendor.name,
        item_category: property ? "property" : "investment",
        item_type: gtmEcommerceOfferTypeMap[offer.type],
        currency: getCurrencyISOCode(offer.currency),
        ...getAmplitudeViewItemRegionProperties(offer.region)
    };

    if (itemListId) {
        eventProperties.item_list_id = itemListId;
    }

    if (itemListName) {
        eventProperties.item_list_name = itemListName;
    }

    if (!property) {
        return eventProperties;
    }

    eventProperties.property_id = property.id;
    eventProperties.variant_name = property.number;

    if (property.area != null) {
        eventProperties.variant_area = property.area;
    }

    if (property.rooms != null) {
        eventProperties.variant_rooms = property.rooms;
    }

    if (property.floor != null) {
        eventProperties.variant_floor = property.floor;
    }

    if (property.price != null) {
        eventProperties.price = property.price;
    }

    return eventProperties;
};
